import React, { Component } from 'react';
import axios from 'axios';



class UploadButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            charm_data: [],
            connected: false,
            characteristic_holder: '',
            isChrome: navigator.userAgent.match(/chrome|chromium|crios/i),
        }
    }

    handleClickOnUpload = () => {

        if (this.state.isChrome) {
            console.log("isChrome: ", this.state.isChrome)
            axios.post(`https://imagilabs-webapp-test.herokuapp.com/charm-uploader`, { code: this.props.data })
                .then(response => {
                    console.log(response.data)
                    this.setState({
                        charm_data: response.data
                    })

                    this.CharmConnection()
                })
                .catch(error => {
                    console.log("ERROR: ", error)
                })
        }
        else {
            alert("It seems like your browser does not support Bluetooth. In order to connect to your imagiCharm switch to Google Chrome!")
        }

    }

    async CharmConnection() {

        const serviceUUID = '4ced8831-02f6-439a-b89b-36f51cbc4feb'
        const characteristicUUID = '4ced8832-02f6-439a-b89b-36f51cbc4feb'

        if (this.state.connected) {

            try {
                for (let i = 0; i < this.state.charm_data.length; i++) {
                    console.log('Sending data', i)
                    let packet = Uint8Array.from(Buffer.from(this.state.charm_data[i], 'hex'))
                    await this.state.characteristic_holder.writeValue(packet)

                }

            }
            catch(error){
                alert("Oops something went wrong, try uploading your project again!")
            }


            

        }
        else {

            try {
                const device = await navigator.bluetooth.requestDevice({
                    filters: [{
                        namePrefix: 'imagiCharm'
                    }],
                    optionalServices: [serviceUUID]
                    // acceptAllDevices: true, optionalServices: [serviceUUID]

                });

                //device.addEventListener('gattserverdisconnected', onDisconnected)

                console.log('Connecting to GATT Server...');
                const server = await device.gatt.connect();

                console.log('Getting Service...');
                const service = await server.getPrimaryService(serviceUUID);

                console.log('Getting Characteristic...');
                const characteristic = await service.getCharacteristic(characteristicUUID);
                this.setState({
                    characteristic_holder: characteristic,
                    connected: true
                })



                for (let i = 0; i < this.state.charm_data.length; i++) {
                    console.log('Sending data', i)
                    let packet = Uint8Array.from(Buffer.from(this.state.charm_data[i], 'hex'))
                    await this.state.characteristic_holder.writeValue(packet)

                }

            } catch (error) {
                console.log("Bluetooth ERROR:", error)
                alert("Oops something went wrong, try uploading your project again!")

            }
        }
    }

    // DISCONNECT SAMPLE FOR LATER 

    // onDisconnectButtonClick() {
    //     if (!bluetoothDevice) {
    //       return;
    //     }
    //     log('Disconnecting from Bluetooth Device...');
    //     if (bluetoothDevice.gatt.connected) {
    //       bluetoothDevice.gatt.disconnect();
    //     } else {
    //       log('> Bluetooth Device is already disconnected');
    //     }
    //   }

    render() {

        return (
            <button disabled={this.props.activity_state} onClick={this.handleClickOnUpload} style={{ height: '50px', width: "90%", marginTop: '10px', marginBottom: '10px' }}>{this.props.children}</button>)
    }
}

export default UploadButton; 
